import {
    BACKEND,
    apiEndpoint,
} from '../utils/api';

const endpoint = 'profile';
export const baseUrl = `${BACKEND}/${endpoint}`;
const backendEndpoint = apiEndpoint({
    api: BACKEND,
    endpoint,
});
const backendImageUploadEndpoint = apiEndpoint({
    api: BACKEND,
    endpoint: 'profile',
    options: {
        timeout: 120000,
    },
});

export async function profileGet() {
    return backendEndpoint.get();
}

export async function profileCreate(profile, hash = null) {
    return backendEndpoint.post('', { profile, hash });
}

export async function updateProfileMeta(profileMeta) {
    return backendEndpoint.put('meta', profileMeta);
}

export async function deleteImage() {
    return backendEndpoint.delete('image');
}

export async function uploadImage(imageData) {
    return backendImageUploadEndpoint.post('image', imageData);
}

export async function deleteAttachment(uuid) {
    return backendEndpoint.delete(`attachment/${uuid}`);
}

export async function uploadAttachment(attachmentData, uploadProgressCallback = () => null) {
    const backendAttachmentUploadEndpoint = apiEndpoint({
        api: BACKEND,
        endpoint: 'profile',
        options: {
            timeout: 120000,
            onUploadProgress(e) {
                const percentCompleted = Math.round((e.loaded * 100) / e.total);
                uploadProgressCallback(percentCompleted);
            },
        },
    });

    return backendAttachmentUploadEndpoint.post('attachment', attachmentData);
}
